import { render, staticRenderFns } from "./TelaNaoAutorizada.vue?vue&type=template&id=c2aac118"
import script from "./TelaNaoAutorizada.vue?vue&type=script&lang=js"
export * from "./TelaNaoAutorizada.vue?vue&type=script&lang=js"
import style0 from "./TelaNaoAutorizada.vue?vue&type=style&index=0&id=c2aac118&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports